import { logRequestFailure } from '@/helpers/request-outcome'
import { api } from '@/helpers/apiClient'
import { pageQuery } from '@/lib/pagination'
import {
  eventQuoteRequestListDtoSchema,
  quoteRequestDtoSchema,
  vendorQuoteRequestListDtoSchema,
  type EventQuoteRequestListDto,
  type QuoteRequestDto,
  type VendorQuoteRequestListDto,
} from '@lib/dto/quote-request.dto'
import type { CreateQuoteRequestInput } from '@lib/input/quote-request.input'

/** Quote requests (docs/vendor-growth.spec.md, "Quote requests"): an event's, and a vendor company's own. */
class QuoteRequestService {
  async send(eventId: string, input: CreateQuoteRequestInput): Promise<QuoteRequestDto> {
    try {
      return await api.post(`/events/${eventId}/quote-requests`, input, quoteRequestDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to send a quote request', { eventId, vendorId: input.vendorId }, error)
      throw error
    }
  }

  async forEvent(eventId: string): Promise<EventQuoteRequestListDto> {
    try {
      return await api.get(`/events/${eventId}/quote-requests`, eventQuoteRequestListDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to list an event’s quote requests', { eventId }, error)
      throw error
    }
  }

  /** The signed-in company's, a page at a time. */
  async own(page: number): Promise<VendorQuoteRequestListDto> {
    try {
      return await api.get(`/vendor/quote-requests${pageQuery(page)}`, vendorQuoteRequestListDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to list quote requests', { page }, error)
      throw error
    }
  }
}

export const quoteRequestService = new QuoteRequestService()
